import LocationMap from './LocationMap.jsx'
import LocationInfo from './LocationInfo.jsx'
const Contact = () => {
    return <div>
        <LocationInfo />
        <LocationMap />
    </div>;
};

export default Contact;